import { Route, Routes } from "react-router-dom";
import DepositReconciliationIndex from ".";
import DepositReconciliationPage from "./reconciliation";

export default function DepositReconciliationRoutes() {
  return (
    <Routes>
      <Route path="/" element={<DepositReconciliationIndex />} />
      <Route path="/:storeCode" element={<DepositReconciliationPage />} />
    </Routes>
  );
}
